const PREFIXO_BIOMETRIA = '/biometria/'
const ROTAS_SEM_CHROME_POR_NOME = ['AcessoNegado', 'cognito']

export interface JanelaDoShell {
  location?: { hash?: unknown }
}

export interface RotaDoShell {
  path?: unknown
  name?: unknown
}

export interface ContextoDoShell {
  caminhoDaRota?: unknown
  nomeDaRota?: unknown
  hashDaJanela?: unknown
}

function texto (valor: unknown): string | null {
  return typeof valor === 'string' ? valor : null
}

export function construirContextoDoShell (
  rota?: RotaDoShell,
  janela?: JanelaDoShell
): ContextoDoShell {
  return {
    caminhoDaRota: rota?.path,
    nomeDaRota: rota?.name,
    hashDaJanela: janela?.location?.hash
  }
}

/** Rotas que renderizam sem o menu e sem o chat lateral. */
export function deveSuprimirChromeDoShell (contexto?: ContextoDoShell): boolean {
  const caminho = texto(contexto?.caminhoDaRota)
  if (caminho !== null && caminho.startsWith(PREFIXO_BIOMETRIA)) return true

  const hash = texto(contexto?.hashDaJanela)
  if (hash !== null && hash.startsWith(`#${PREFIXO_BIOMETRIA}`)) return true

  const nome = texto(contexto?.nomeDaRota)
  return nome !== null && ROTAS_SEM_CHROME_POR_NOME.includes(nome)
}
